module.exports = __webpack_public_path__ + "static/img/clipboard.35dea81d.svg";